// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/activities/v1/presence.proto (package msh.trait.activities.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.activities.v1.PresenceTrait
 */
export const PresenceTrait = proto3.makeMessageType(
  "msh.trait.activities.v1.PresenceTrait",
  [],
);

/**
 * @generated from message msh.trait.activities.v1.PresenceTrait.PresenceEvent
 */
export const PresenceTrait_PresenceEvent = proto3.makeMessageType(
  "msh.trait.activities.v1.PresenceTrait.PresenceEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(PresenceTrait_PresenceEvent_PresenceStatus) },
    { no: 3, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
  ],
  {localName: "PresenceTrait_PresenceEvent"},
);

/**
 * @generated from enum msh.trait.activities.v1.PresenceTrait.PresenceEvent.PresenceStatus
 */
export const PresenceTrait_PresenceEvent_PresenceStatus = proto3.makeEnum(
  "msh.trait.activities.v1.PresenceTrait.PresenceEvent.PresenceStatus",
  [
    {no: 0, name: "PRESENCE_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRESENCE_STATUS_ABSENT", localName: "ABSENT"},
    {no: 2, name: "PRESENCE_STATUS_PRESENT", localName: "PRESENT"},
    {no: 3, name: "PRESENCE_STATUS_UNKNOWN", localName: "UNKNOWN"},
  ],
);

